import { SET_POLICY_TEST_OVERRIDE } from '../../constants/actions/policy';

export function setPolicyTestOverride(payload) {
    return {
        type: SET_POLICY_TEST_OVERRIDE,
        payload,
    };
}
